import React from 'react'
import SectionHead from '../components/SectionHead'
import AnimatePage from '../components/AnimatePage'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import { displayImage } from '../helpers/config'
import Wrapper from '../helpers/Wrapper'
import { motion } from 'framer-motion'
import LinkButton from '../ui/LinkButton'

function Store() {

    const { data } = useQuery({
        queryKey: ['our-store-one'],
        queryFn: async () => {
            const res = await apiClient.get('/shop/locations');
            return res.data
        }
    })

    return (
        <AnimatePage>
            <Wrapper>
                <div className='w-full relative mt-5'>
                    {/* Page Head */}
                    <SectionHead
                        title='Our Stores'
                        description="Discover our stores, where quality, style, and service come together to create an exceptional shopping experience. "
                    />


                    {/* Our Stores */}
                    <div className="mt-14">
                        {data && data?.length > 0 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-8">
                                {data?.map((store, i) => (
                                    <div className='w-full' key={i}>
                                        {/* Image */}
                                        <div className="relative pt-[65%] overflow-hidden rounded-xl cursor-pointer">
                                            <motion.img
                                                transition={{ duration: 0.3 }}
                                                whileHover={{ scale: 1.1 }}
                                                src={displayImage(store?.image)} alt=""
                                                className="absolute w-full h-full object-cover top-0 left-0
                                                bottom-0 right-0"
                                            />
                                        </div>

                                        {/* Descriptions */}
                                        <div className="w-full space-y-2 mt-3.5">
                                            <h3 className="text-xl md:text-2xl">{store?.name}</h3>
                                            <div className="">
                                                <div className="space-y-1">
                                                    <p className="text-gray-500">{store?.address}</p>
                                                    <p className="text-gray-500">{store?.telephone}</p>
                                                    <p className="text-gray-500">{store?.email}</p>

                                                </div>
                                                <div className="mt-3">
                                                    <p className="text-gray-500">{store?.time_avalable1}</p>
                                                    <p className="text-gray-500">{store?.time_avalable2}</p>
                                                </div>
                                            </div>

                                            {/* Link */}
                                            <div className='pt-4'>
                                                <LinkButton target='_blank' to={`${store?.google_address_link}`}>Get Direction</LinkButton>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </Wrapper>
        </AnimatePage>
    )
}

export default Store